import React, { useState, Fragment } from "react";
import { post } from "../../lib/Fetching";
import Button from "../Button";
import PrintAliquotBarcodes from "./PrintAliquotBarcodes";

export default function PrintSampleBarcodes({
  sample_ids,
  disabled,
  printAliquotBarcodes = true
}) {
  const [highlighted, setHighlighted] = useState(false);
  const [aliquotPrinting, showAliquotPrinting] = useState(false);
  const [text, setText] = useState("Print Sample Barcodes");

  const printSamples = () => {
    post("/printing/api/print_samples", {
      sample_ids
    })
      .then(json => {
        if (json.errors) {
          alert(json.errors);
        } else {
          setHighlighted(true);
          setText("Printed!!");
          setTimeout(() => {
            setHighlighted(false);
            setText("Print Barcodes");
          }, 2000);
        }
      })
      .catch(errors => {
        alert(errors);
      });
  };

  return (
    <Fragment>
      <Button
        tiny
        title={text}
        highlight={highlighted}
        disabled={disabled}
        onClick={printSamples}
      />
      {printAliquotBarcodes && (
        <Fragment>
          &nbsp;
          <Button
            tiny
            title="Batch Print Aliquot Labels"
            disabled={disabled || sample_ids.length == 0}
            onClick={() => showAliquotPrinting(!aliquotPrinting)}
          />
          {aliquotPrinting && (
            <PrintAliquotBarcodes sampleIds={sample_ids} disabled={disabled} />
          )}
        </Fragment>
      )}
    </Fragment>
  );
}
